/**
 * Servicio CRUD de empresas.
 */
import { apiClient } from "./authService";

export const empresaService = {
  async obtenerTodas() {
    const response = await apiClient.get("/empresas/");
    return response.data;
  },

  async obtenerPorId(empresaId) {
    const response = await apiClient.get(`/empresas/${empresaId}`);
    return response.data;
  },

  async crear(data) {
    const response = await apiClient.post("/empresas/", data);
    return response.data;
  },

  async actualizar(empresaId, data) {
    const response = await apiClient.put(`/empresas/${empresaId}`, data);
    return response.data;
  },

  async eliminar(empresaId) {
    const response = await apiClient.delete(`/empresas/${empresaId}`);
    return response.data;
  },
};
